module.exports = __webpack_public_path__ + "static/media/partner10.fbdb5a82.jpg";